export enum DocStatusEnum {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    READY_TO_PROCESS = 'READY TO PROCESS',
    HOLD = 'HOLD',
    READY_TO_SHIP = 'READY TO SHIP',
    SHIPPED = 'SHIPPED',
}